import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

interface SeoObject {
  title: string,
  description: string,
  keywords?: string,
  image?: string,
  url: string
}

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private title: Title, private meta: Meta) { }

  /**
   * Set the title for the page and meta tags
   * @param param parameters for the meta tags and title
   */
  public setSeo(data: SeoObject): void {
    this.setTitle(data.title);
    this.setMetaTags(data);
  }

  /**
   * Set meta tags for the page
   * @param param parameters for the meta tags
   */
  public setMetaTags(data: SeoObject): void {
    let description = data.description ? (data.description.length >= 160 ? data.description.substring(0, 157).replace(/<[^>]+>/g, '') + '...' : data.description.replace(/<[^>]+>/g, '')) : '';
    let title = data.title ? (data.title.length >= 70 ? data.title.substring(0, 67).replace(/<[^>]+>/g, '') + '...' : data.title.replace(/<[^>]+>/g, '')) : '';
    this.meta.addTags([
      //{ name: 'robots', content: 'index, follow' },
      { charset: 'UTF-8' },
      { name: 'description', content: description }, 
      { name: 'og:type', content: 'website' },
      { name: 'og:url', content: data.url },
      { name: 'og:title', content: title },
      { name: 'og:description', content: description },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:url', content: data.url },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
    ]);

    if (data.image) {
      this.meta.addTags([
        { name: 'twitter:image', content: data.image },
        { name: 'og:image', content: data.image },
      ]);
    }
  }

  /**
   * Set the title of the page
   * @param title title of the page
   */
  public setTitle(title: string): void {
    this.title.setTitle(title.length >= 70 ? title.substring(0, 67).replace(/<[^>]+>/g, '') + '...' : title.replace(/<[^>]+>/g, ''));
  }
}
